module.exports = __webpack_public_path__ + "static/media/civic-master-builders.56817979.svg";